import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../ui';

const InvoiceFilters = ({ filtres, clients, handleFiltreChange, resetFiltres }) => {
  const inputClass = "w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500";

  return (
    <div className="bg-white rounded-xl border border-gray-200 mb-6 overflow-hidden">
      <div className="px-5 py-4 border-b border-gray-100">
        <h4 className="font-medium text-gray-800 text-sm">Filtres de recherche</h4>
      </div>
      <div className="p-5">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <div>
            <label className="block text-xs font-medium mb-1.5 text-gray-600">Statut</label>
            <select name="status" value={filtres.status} onChange={handleFiltreChange} className={inputClass}>
              <option value="">Tous les statuts</option>
              <option value="draft">Brouillon</option>
              <option value="sent">Envoyée</option>
              <option value="paid">Payée</option>
              <option value="partial">Partiel</option>
              <option value="cancelled">Annulée</option>
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium mb-1.5 text-gray-600">Client</label>
            <select name="clientId" value={filtres.clientId} onChange={handleFiltreChange} className={inputClass}>
              <option value="">Tous les clients</option>
              {clients.map(clientItem => (
                <option key={clientItem._id} value={clientItem._id}>
                  {clientItem.companyName}{clientItem.contactName ? ` - ${clientItem.contactName}` : ''}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium mb-1.5 text-gray-600">Date début</label>
            <input type="date" name="dateDebut" value={filtres.dateDebut} onChange={handleFiltreChange} className={inputClass} />
          </div>
          <div>
            <label className="block text-xs font-medium mb-1.5 text-gray-600">Date fin</label>
            <input type="date" name="dateFin" value={filtres.dateFin} onChange={handleFiltreChange} className={inputClass} />
          </div>
        </div>
        <div className="mt-4 flex justify-end">
          <Button variant="secondary" size="sm" onClick={resetFiltres}>Réinitialiser les filtres</Button>
        </div>
      </div>
    </div>
  );
};

InvoiceFilters.propTypes = {
  filtres: PropTypes.shape({ status: PropTypes.string, clientId: PropTypes.string, dateDebut: PropTypes.string, dateFin: PropTypes.string }).isRequired,
  clients: PropTypes.arrayOf(PropTypes.shape({ _id: PropTypes.string.isRequired, companyName: PropTypes.string.isRequired, contactName: PropTypes.string })).isRequired,
  handleFiltreChange: PropTypes.func.isRequired,
  resetFiltres: PropTypes.func.isRequired,
};

export default InvoiceFilters;
